import type { IconDefinition } from '../../types'

export default {
  details: [32, 32, [], '', 'M29 4C30.625 4 32 5.375 32 7C32 8 31.5 8.875 30.75 9.4375L17.1875 19.625C16.4375 20.1875 15.5 20.1875 14.75 19.625L1.1875 9.4375C0.4375 8.875 0 8 0 7C0 5.375 1.3125 4 3 4H29ZM13.5625 21.25C15 22.3125 16.9375 22.3125 18.375 21.25L32 11V24C32 26.25 30.1875 28 28 28H4C1.75 28 0 26.25 0 24V11L13.5625 21.25Z'],
  name: 'uiEnvelopeSolid'
} as IconDefinition
